webpackJsonp([5],{

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoxSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.shadow, this.props.shadow), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.hidden, this.props.hidden), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          shadow = _props.shadow,
          restProps = _objectWithoutProperties(_props, ['children', 'shadow']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        this.props.children
      );
    }
  }]);

  return Box;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Box.defaultProps = {
  className: '',
  shadow: false,
  hidden: false
};


var BoxSection = function BoxSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      disabledContent = _ref.disabledContent,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'disabled', 'disabledContent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.section, className) }),
    children,
    disabled && _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.disabledOverlay
    }, void 0, disabledContent)
  );
};

BoxSection.defaultProps = {
  className: '',
  disabled: false,
  disabledContent: null
};

/* harmony default export */ __webpack_exports__["b"] = (Box);


/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Ob7a","shadow":"_3NCC3","hidden":"_170VA","section":"UNjnV","disabledOverlay":"_2jdoD"};

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MastheadOverlap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Masthead = function (_Component) {
  _inherits(Masthead, _Component);

  function Masthead() {
    _classCallCheck(this, Masthead);

    return _possibleConstructorReturn(this, (Masthead.__proto__ || Object.getPrototypeOf(Masthead)).apply(this, arguments));
  }

  _createClass(Masthead, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.overlap, this.props.overlap), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.plain, this.props.plain), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          overlap = _props.overlap,
          plain = _props.plain,
          restProps = _objectWithoutProperties(_props, ['children', 'overlap', 'plain']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        _extends({}, restProps, { className: this.getClassName() }),
        children
      );
    }
  }]);

  return Masthead;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Masthead.defaultProps = {
  className: '',
  overlap: false,
  plain: false
};


var MastheadOverlap = function MastheadOverlap(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['className', 'children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.overlapEl, className) }),
    children
  );
};

MastheadOverlap.defaultProps = {
  className: ''
};

/* harmony default export */ __webpack_exports__["b"] = (Masthead);


/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3fRR8","overlap":"_3MekN","plain":"_2QEMQ","overlapEl":"_3opO9"};

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_Page__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_layouts_Masthead__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_layouts_Container__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_layouts_Box__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_djedi_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _templateObject = _taggedTemplateLiteral(['\n                Genom att registrera en ans\xF6kan om att bli ledare\n                samtycker den s\xF6kande till att Bolaget behandlar\n                personuppgifter om denne i den utstr\xE4ckning som kr\xE4vs\n                f\xF6r hantering av ans\xF6kan. Om s\xF6kanden inte antas som\n                ledare \xE5tar sig Bolaget sig att p\xE5 beg\xE4ran radera\n                ingivna handlingar, s\xE5som CV och referenser. S\xF6kande \xE4r\n                inf\xF6rst\xE5dd med att en registrerad ans\xF6kan inte medf\xF6r\n                n\xE5gon r\xE4tt att bli antagen som ledare utan det \xE4r upp\n                till Bolaget att i varje enskilt fall bed\xF6ma enskild\n                s\xF6kandes l\xE4mplighet f\xF6r uppdraget. Om s\xF6kande inte\n                antas som ledare har Bolaget r\xE4tt att omg\xE5ende, och\n                utan f\xF6reg\xE5ende meddelande, st\xE4nga ner s\xF6kandens konto.\n              '], ['\n                Genom att registrera en ans\xF6kan om att bli ledare\n                samtycker den s\xF6kande till att Bolaget behandlar\n                personuppgifter om denne i den utstr\xE4ckning som kr\xE4vs\n                f\xF6r hantering av ans\xF6kan. Om s\xF6kanden inte antas som\n                ledare \xE5tar sig Bolaget sig att p\xE5 beg\xE4ran radera\n                ingivna handlingar, s\xE5som CV och referenser. S\xF6kande \xE4r\n                inf\xF6rst\xE5dd med att en registrerad ans\xF6kan inte medf\xF6r\n                n\xE5gon r\xE4tt att bli antagen som ledare utan det \xE4r upp\n                till Bolaget att i varje enskilt fall bed\xF6ma enskild\n                s\xF6kandes l\xE4mplighet f\xF6r uppdraget. Om s\xF6kande inte\n                antas som ledare har Bolaget r\xE4tt att omg\xE5ende, och\n                utan f\xF6reg\xE5ende meddelande, st\xE4nga ner s\xF6kandens konto.\n              ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }








var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_2_layouts_Masthead__["b" /* default */], {
  overlap: true,
  plain: true
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_layouts_Container__["a" /* default */], {
  size: 'medium'
}, void 0, _jsx('h1', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_djedi_react__["Node"], {
  uri: 'application-terms/heading'
}, void 0, 'Villkor f\xF6r ans\xF6kan'))));

/* harmony default export */ __webpack_exports__["default"] = (function () {
  return _jsx(__WEBPACK_IMPORTED_MODULE_1_layouts_Page__["a" /* default */], {
    title: 'Villkor f\xF6r ans\xF6kan',
    plain: true
  }, void 0, _ref, _jsx(__WEBPACK_IMPORTED_MODULE_2_layouts_Masthead__["a" /* MastheadOverlap */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_layouts_Container__["a" /* default */], {
    size: 'medium'
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_layouts_Box__["b" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_layouts_Box__["a" /* BoxSection */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_djedi_react__["Node"], {
    uri: 'application-terms/text.md'
  }, void 0, Object(__WEBPACK_IMPORTED_MODULE_5_djedi_react__["md"])(_templateObject)))))));
});

/***/ })

});


// WEBPACK FOOTER //
// static/ApplicationTerms.fcb262f1662dc51843d0.js